import IndexAdmin from '../views/Admin/Index'
import FileManager from '../views/Admin/Events/FileManager'

const LAYOUT = 'AdminLayout';

export const AdminRouter = [
    {
        path: '/administrator',
        name: 'IndexAdmin',
        component: IndexAdmin,
        meta: {layout: LAYOUT}
    },
    {
      path: '/file-manager/events/:event_id/category/:category_id',
      name: 'FileManager',
      component: FileManager,
      meta: {layout: LAYOUT}
  },    
];
